module.exports = ":host .price-tag-label {\n  font-weight: 700;\n  color: #4990e0;\n  font-size: 14px;\n  padding: 5px 10px;\n  background-color: #eaf4fd;\n  display: inline-block;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 1;\n      -ms-flex: 1 1;\n          flex: 1 1;\n  white-space: nowrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/price-tag/price-tag.component.scss
// module id = ./web/modern/components/price-tag/price-tag.component.scss
// module chunks = 0